import { H3 } from '@atlassian/amkt-common';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ScreenClassRender } from 'react-grid-system';

import styles from './SolutionBodyBottomSection.less';

export default class SolutionBodyBottomSection extends Component {
  static propTypes = {
    coloredBackground: PropTypes.bool,
    heading: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    paragraph: PropTypes.node.isRequired,
  };

  static defaultProps = {
    coloredBackground: true,
  };

  render() {
    const className = classNames({
      [styles.sectionInner]: true,
      // @ts-expect-error [MC-2850] - TS2339 - Property 'coloredBackground' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
      [styles.firstSection]: this.props.coloredBackground,
    });

    return (
      <div className={styles.solutionBodyBottomSection}>
        <div className={className}>
          <ScreenClassRender render={this.renderText}>
            <span />
          </ScreenClassRender>
        </div>
      </div>
    );
  }

  renderText = (sc: any) => {
    // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
    const paragraph = this.props.paragraph;
    const smallScreenClass = sc === 'md' || sc === 'sm' || sc === 'xs';

    const className = classNames({
      [styles.contentContainer]: true,
      [styles.smallScreenClass]: smallScreenClass,
    });

    return (
      <div className={className}>
        <div className={styles.imageContainer}>
          {/* @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'. */}
          <img className={styles.image} src={this.props.image} alt="" />
        </div>
        <div className={styles.text}>
          {/* @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'. */}
          <H3 className={styles.heading}>{this.props.heading}</H3>
          <div className={styles.paragraph}>{paragraph}</div>
        </div>
      </div>
    );
  };
}
